// Library imports
import React from "react";

// User Component imports
import { prettySize } from "../../utils/videoFile";

const formatFps = (fps) => (Number.isInteger(fps) ? String(fps) : fps.toFixed(2));

// 添付した動画の最適化の状態と「最適化しない」の切り替え
const OptimizeStatus = ({ entry, disabled, onToggle, className = "" }) => {
    if (!entry || entry.bad) return null;
    const { status, info } = entry;

    let state = null;
    if (status === 'queued') {
        state = <span className="ops-optimize-state is-busy"><i className="bi bi-hourglass-split" />最適化の順番待ち</span>;
    } else if (status === 'optimizing') {
        state = <span className="ops-optimize-state is-busy"><i className="bi bi-arrow-repeat ops-spin" />最適化中 {Math.round((entry.progress || 0) * 100)}%</span>;
    } else if (status === 'done') {
        state = (
            <span className="ops-optimize-state is-done">
                <i className="bi bi-check-circle-fill" />
                最適化済み {prettySize(entry.sourceSize)} → {prettySize(entry.size)}
                {info && ` · ${info.width}×${info.height} · ${formatFps(info.fps)}fps`}
            </span>
        );
    } else if (status === 'error') {
        state = <span className="ops-error-text"><i className="bi bi-x-circle-fill" />{entry.error}</span>;
    } else if (status === 'skipped') {
        state = (
            <span className="ops-optimize-state">
                <i className="bi bi-dash-circle" />{entry.canOptimize ? "最適化せずにそのまま送ります" : "WebM はそのまま送ります"}（{prettySize(entry.sourceSize)}）
            </span>
        );
    }

    return (
        <div className={"ops-optimize" + (className ? " " + className : "")}>
            {state}
            {entry.canOptimize && !entry.mustOptimize &&
                <label className="ops-optimize-skip" title="変換済みの動画を再圧縮せずにそのまま使います">
                    <input type="checkbox" checked={!entry.optimize} disabled={disabled} onChange={(e) => onToggle(!e.target.checked)} />
                    最適化しない
                </label>
            }
        </div>
    );
};

// idle から作ったウィジェット表示動画の目印
export const AutoMiniBadge = ({ small = false }) => (
    <span className={"ops-auto-mini-badge" + (small ? " is-small" : "")}><i className="bi bi-magic" />idle から作成</span>
);

// idle からウィジェット表示動画を作るかの切り替え
export const AutoMiniToggle = ({ toggle, disabled, label, className = "" }) => (
    <label className={"ops-auto-mini-toggle " + className} title="idle を縮小してウィジェット表示動画（長辺 480px）を作ります">
        <input type="checkbox" checked={toggle.checked} disabled={disabled} onChange={(e) => toggle.onChange(e.target.checked)} />
        {label}
    </label>
);

export default OptimizeStatus;
